__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/4ddcd73/_next/";